import { downloadService } from './downloads';
import { projectCrud } from './crud';
import { demUpload } from './dem';
import { collaborationService } from './collaboration';
import { statisticsService } from './statistics';
import { structureService } from './structure';
import { shouldShowPaymentModal } from './types';
class ProjectService {
    constructor() {
        // Downloads
        this.initDownloadListeners = () => downloadService.initListeners();
        this.createProjectDownload = (projectId) => downloadService.createProjectDownload(projectId);
        this.getReadyDownloadForProject = (projectId) => downloadService.getReadyDownloadForProject(projectId);
        // CRUD
        this.createProjectFromPolygon = (req) => projectCrud.createFromPolygon(req);
        this.listUserProjects = () => projectCrud.list();
        this.updateProject = (projectId, name, description, standardContourUnit, customContours) => projectCrud.update(projectId, name, description, standardContourUnit, customContours);
        this.removeProject = (projectId) => projectCrud.remove(projectId);
        this.updateProjectDataSourceMetadata = (projectId, metadata) => projectCrud.updateDataSourceMetadata(projectId, metadata);
        // DEM
        this.initProjectFromDEM = (name, desc) => demUpload.init(name, desc);
        this.finalizeDEMUpload = (projectId, aoi) => demUpload.finalize(projectId, aoi);
        this.startDemoProcessing = (projectId) => demUpload.startDemoProcessing(projectId);
        this.requestFullResolutionBuild = (projectId) => demUpload.requestFullResolutionBuild(projectId);
        this.getDemoSlotInfo = () => demUpload.getDemoSlotInfo();
        // Collaboration
        this.inviteCollaborator = (projectId, email, firstName, lastName, role, acknowledgeSeatCharge) => collaborationService.invite(projectId, email, firstName, lastName, role, acknowledgeSeatCharge);
        this.removeCollaborator = (projectId, userId) => collaborationService.remove(projectId, userId);
        this.listCollaborators = (projectId) => collaborationService.list(projectId);
        // Statistics
        this.getProjectStatistics = (projectId) => statisticsService.get(projectId);
        // Structure
        this.getUserProjectStructure = (projectId) => structureService.getStructure(projectId);
        this.getUserProjectArtifact = (artifactId) => structureService.getArtifact(artifactId);
        this.retryLayerProcessing = (projectId, layerNames) => structureService.retryLayerProcessing(projectId, layerNames);
        this.recordLayerOpened = (projectId, objectKey) => structureService.recordLayerOpened(projectId, objectKey);
        // Utility
        this.shouldShowPaymentModal = (project) => shouldShowPaymentModal(project);
    }
}
export const projectService = new ProjectService();
